import { render, staticRenderFns } from "./mr_collapsible_extension.vue?vue&type=template&id=4df0b51a&"
import script from "./mr_collapsible_extension.vue?vue&type=script&lang=js&"
export * from "./mr_collapsible_extension.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports